import React from 'react';
import { Button } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormMicCatalogs } from './FormMicCatalogs';
import { Dialog } from 'primereact/dialog';


export const ModalMicCatalogs = (props) => {
    const {
        modal, tittle, toggle, method,
        name, description, estatus,
        handleInputChange, loading, closeDialog,
        saveCreate, saveUpdateMic, saveDeleteMic
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-ruler f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {tittle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v38 `}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdateMic}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }
        >
            {
                method === "create"
                    ? <FormMicCatalogs
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, name, description, estatus, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormMicCatalogs
                            button={ModalButtonUpdate}
                            {...{ closeDialog, loading, handleInputChange, methodAction: saveUpdateMic, name, description, estatus }}
                        />
                        :
                        null
            }
        </Dialog>
    )
}